import React from 'react'
import { useTranslation } from 'react-i18next'
import Select from '../../../packages/kiti/components/form/Select'

const SlaValueSelect = ({ mergeOptions = [], returnObject, ...props }) => {
  const { t } = useTranslation('serviceOrders')
  const options = [
    { name: t('slaValue.days'), id: 'day' },
    { name: t('slaValue.hours'), id: 'hour' },
    { name: t('slaValue.minutes'), id: 'minute' }
  ]

  return <Select options={options} selectOnlyId={returnObject ? false : true} {...props} />
}

export default SlaValueSelect
